import { InputNumber as AntdNumberInput } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled, { css } from 'styled-components';

import { colors } from '../../styles/colors';

const StyledInputNumber = styled(AntdNumberInput)`
  width: ${(props) => props.width || '100%'};
  border: ${(props) =>
    !props.disabled && props.error
      ? `1px solid ${colors['red']['5']} !important`
      : `1px solid ${colors['gray']['3']} !important`};
  border-radius: 3px;
  ${(props) =>
    props.isMobile &&
    css`
      height: 40px;
      padding-top: 3px;
    `};
  .ant-input-number-input {
    font-size: ${(props) => (props.isMobile ? '16px !important' : '14px !important')};
  }

  &:hover {
    // If disabled, gray border
    // if error, red border
    // if no error, indigo border
    box-shadow: none;
    border-color: ${(props) =>
      props.disabled
        ? `${colors['gray']['3']} !important`
        : props.error
        ? `${colors['red']['5']} !important`
        : `${colors['indigo']['7']} !important`};
  }

  &:focus {
    // If disabled, no border shadow and gray border
    // if error, red border shadow and red border
    // if no error, indigo border shadow and indigo border
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : props.error
        ? `0px 0px 4px ${colors['red']['7']} !important`
        : `0px 0px 4px ${colors['indigo']['3']} !important`};
    border-color: ${(props) =>
      props.disabled
        ? `${colors['gray']['3']} !important`
        : props.error
        ? `${colors['red']['5']} !important`
        : `${colors['indigo']['7']} !important`};
  }

  &:active {
    // If disabled, no border shadow and gray border
    // if error, red border shadow and red border
    // if no error, indigo border shadow and indigo border
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : props.error
        ? `0px 0px 4px ${colors['red']['7']}`
        : `0px 0px 4px ${colors['indigo']['3']}`};
    border-color: ${(props) =>
      props.disabled
        ? colors['gray']['3']
        : props.error
        ? colors['red']['5']
        : colors['indigo']['7']};
  }

  &:focus-within {
    // If disabled, no border shadow and gray border
    // if error, red border shadow and red border
    // if no error, indigo border shadow and indigo border
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : props.error
        ? `0px 0px 4px ${colors['red']['7']}`
        : `0px 0px 4px ${colors['indigo']['3']}`};
    border-color: ${(props) =>
      props.disabled
        ? colors['gray']['3']
        : props.error
        ? colors['red']['5']
        : colors['indigo']['7']};
  }
`;

/**
 * Primary UI component for user interaction
 */

const InputNumber = ({ placeholder, disabled, error, handleChange, width, isMobile, ...props }) => {
  return (
    <StyledInputNumber
      placeholder={placeholder}
      onChange={handleChange}
      disabled={disabled}
      error={error}
      width={width}
      isMobile={isMobile}
      {...props}
    />
  );
};

InputNumber.propTypes = {
  /**
   * Select contents
   */
  placeholder: PropTypes.string,

  disabled: PropTypes.bool,

  error: PropTypes.bool,

  handleChange: PropTypes.func,

  width: PropTypes.string,

  isMobile: PropTypes.bool,
};

InputNumber.defaultProps = {
  disabled: false,
  error: false,
  isMobile: false,
};

export { InputNumber };
